(function () {
	'use strict';

	angular.module('app',
			[
				// Angular modules 
				'ngRoute',
				'ngSanitize'

				// Custom modules 

				// 3rd Party Modules
			])
		.config([
			'$httpProvider', '$locationProvider',
			function ($httpProvider, $locationProvider) {
				$httpProvider.defaults.withCredentials = false;
				$locationProvider.html5Mode({ enabled: true, requireBase: false, rewriteLinks: false });
			}
        ]);

    angular.element(document).ready(function () {
        angular.bootstrap(document, ['app']);
    });

})();


//////////////////
// WEBPACK FOOTER
// ./static/common/js/modules/_app.js
// module id = 8
// module chunks = 0